import React from "react";
import { faFileCsv } from "@fortawesome/free-solid-svg-icons";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { withRouter } from "react-router-dom";
import s from "./styles.scss";
import PagedTable from "../common/PagedTable";
import { QueryResponse } from "../../../types/QueryResponse";
import {
  UncontrolledTooltip,
  Container,
  Form,
  Row,
  Button,
  Input,
  FormGroup,
  Label,
  Col
} from "reactstrap";
import { handleRequestError } from "../../../utils/helpers";
import DatePicker from "../common/DatePicker";
import moment from "moment";
import { RouterProps } from "../../../toolkit/decorators/Artifact";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faSearch } from "@fortawesome/free-solid-svg-icons";
import IUserSelectorConnected from "../../../toolkit/baseForms2Commons/iUserSelector/IUserSelectorConnected";
import { QueryArguments } from "../../../types-business/QueryArguments";

interface Binnacle {
  createdDate: string;
  eventoUserId: string;
  modulo: string;
  actividad: string;
}

interface Props extends RouterProps {
  getBinnacleByPartner: (params?: QueryArguments) => any;
  modules?: string[];
  loadingModules?: boolean;
  roles?: object[];
  generateCSVByPartner: (callback: any, params?: QueryArguments) => any;
}

interface State {
  searching: boolean;
  searched: boolean;
  search: any;
  binnacles: QueryResponse<Binnacle>;
  specialFilters: boolean;
  generatingCSV: boolean;
}

class Binnacles extends React.Component<Props, State> {
  state = {
    binnacles: [] as any,
    searching: false,
    searched: false,
    specialFilters: false,
    generatingCSV: false,
    search: {
      userId: null,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      module: null,
      activity: null,
      role: null,
      page: 0,
      size: 100
    }
  };

  headers = [
    { name: "Usuario", id: "username", minWidth: 20 },
    { name: "Membresia", id: "membership", minWidth: 10 },
    { name: "Fecha", id: "datetime", minWidth: 10 },
    { name: "Modulo", id: "module", minWidth: 10 },
    { name: "Descripción", id: "activity", minWidth: 50 }
  ];

  stateSpecialFilters = () =>
    this.setState(state => ({ specialFilters: !state.specialFilters }));

  onFetchData = async ({ pageSize: size, page }) => {
    await this.setState(state => ({
      ...state,
      specialFilters: false,
      search: { ...this.state.search, size, page }
    }));
    await this.search();
  };

  onChangeFilter = (value, name) => {
    const search = {
      ...this.state.search,
      [`${name}`]: value ? value : null
    };
    this.setState(state => ({ ...state, search }));
  };

  search = async () => {
    if (!this.state.search.startDate || !this.state.search.endDate) {
      alert("Las fechas inicial y final son obligatorias");
      return;
    }

    this.setState(state => ({
      ...state,
      specialFilters: false,
      searching: true
    }));

    let search = this.state.search;

    this.props
      .getBinnacleByPartner(search)
      .then(({ value: { data } }) => {
        this.setState(state => ({
          ...state,
          binnacles: data,
          searching: false,
          searched: true
        }));
      })
      .catch((err, f?: Function) => {
        handleRequestError(err, f);
        this.setState(state => ({ ...state, searching: false }));
      });
  };

  clearFilters = () => {
    this.setState(state => ({
      ...state,
      search: {
        ...this.state.search,
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        userId: null,
        module: null,
        activity: null,
        role: null
      }
    }));
  };

  render() {
    const { modules = [], loadingModules = false, roles = [] } = this.props;
    return (
      <Container className="mt-3 mb-5 p-0">
        <Row className="mb-1">
          <Col sm="12">
            <strong>Campos requeridos </strong>
            <strong className="text-danger">*</strong>
          </Col>
        </Row>
        <Form
          onSubmit={async e => {
            e.preventDefault();
            await this.search();
          }}
        >
          <Row>
            <Col sm="3">
              <DatePicker
                id="startDate"
                name="startDate"
                label="* Fecha desde"
                selected={this.state.search.startDate}
                onChange={e =>
                  this.onChangeFilter(
                    moment(e).format("YYYY-MM-DD"),
                    "startDate"
                  )
                }
              />
            </Col>
            <Col sm="3">
              <DatePicker
                id="endDate"
                name="endDate"
                label="* Fecha hasta"
                selected={this.state.search.endDate}
                onChange={e =>
                  this.onChangeFilter(moment(e).format("YYYY-MM-DD"), "endDate")
                }
              />
            </Col>
            {this.state.specialFilters && (
              <>
                <Col sm="3">
                  <FormGroup>
                    <Label for="module">Módulo:</Label>
                    <Input
                      type="select"
                      name="module"
                      id="module"
                      value={this.state.search.module || ""}
                      onChange={e =>
                        this.onChangeFilter(e.target.value, "module")
                      }
                      disabled={loadingModules}
                    >
                      <option value="">Seleccione un módulo</option>
                      {loadingModules ? (
                        <option disabled>Cargando módulos...</option>
                      ) : (
                        modules.map(mod => (
                          <option key={mod} value={mod}>
                            {mod}
                          </option>
                        ))
                      )}
                    </Input>
                  </FormGroup>
                </Col>
                <Col sm="3">
                  <FormGroup>
                    <Label for="role">Rol:</Label>
                    <Input
                      type="select"
                      name="role"
                      id="role"
                      value={this.state.search.role || ""}
                      onChange={e =>
                        this.onChangeFilter(e.target.value, "role")
                      }
                      disabled={loadingModules}
                    >
                      <option value="">Seleccione un rol</option>
                      {loadingModules ? (
                        <option disabled>Cargando roles...</option>
                      ) : (
                        roles
                          .filter(role => role.active)
                          .map(role => (
                            <option key={role.id} value={role.id}>
                              {role.description}
                            </option>
                          ))
                      )}
                    </Input>
                  </FormGroup>
                </Col>
                <Col sm="6">
                  <FormGroup>
                    <IUserSelectorConnected
                      name="userId"
                      key={this.state.search.userId || "empty"}
                      init={this.state.search.userId}
                      label="Usuario"
                      onChange={value =>
                        this.onChangeFilter(value || null, "userId")
                      }
                      includeSystemUsers={false}
                      includeSuspendedUsers={true}
                    />
                  </FormGroup>
                </Col>
                <Col sm="6">
                  <FormGroup>
                    <Label for="activity">Actividad:</Label>
                    <Input
                      type="text"
                      name="activity"
                      id="activity"
                      placeholder="Describa la actividad"
                      value={this.state.search.activity || ""}
                      onChange={e =>
                        this.onChangeFilter(e.target.value, "activity")
                      }
                    />
                  </FormGroup>
                </Col>
              </>
            )}

            {this.state.specialFilters && <Col sm="6"></Col>}
            <Col sm="2">
              <Button
                block
                className="mt-4 d-inline-flex align-items-center justify-content-center"
                type="submit"
                disabled={
                  this.state.searching ||
                  !this.state.search.startDate ||
                  !this.state.search.endDate
                }
              >
                {this.state.searching ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm mr-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Buscando...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faSearch} className="mr-2" />
                    Buscar
                  </>
                )}
              </Button>
            </Col>
            <Col sm="2">
              <Button
                block
                outline
                color="secondary"
                className="mt-4"
                id="bSpecialFilter"
                onClick={this.stateSpecialFilters}
              >
                {this.state.specialFilters ? "- Filtro" : "+ Filtro"}
              </Button>

              <UncontrolledTooltip target="bSpecialFilter" placement="bottom">
                Módulo, Rol, Usuario y Actividad
              </UncontrolledTooltip>
            </Col>
            <Col sm="2">
              <Button
                block
                outline
                color="secondary"
                className="mt-4"
                onClick={this.clearFilters}
                disabled={this.state.searching}
              >
                <FontAwesomeIcon icon={faTimesCircle} className="mr-2" />
                Limpiar filtros
              </Button>
            </Col>
          </Row>
        </Form>

        <Container>
          <Row>
            {!this.state.searched ? (
              <Col sm="12">
                <div className="text-center p-5 bg-light rounded">
                  <p className="mb-0">
                    Ingrese los filtros y haga clic en Buscar para ver los
                    registros
                  </p>
                </div>
              </Col>
            ) : this.state.binnacles &&
              this.state.binnacles.content &&
              this.state.binnacles.content.length > 0 ? (
              <Col sm="12">
                <hr className="border-secundary opacity-75" />
                <Row>
                  <Col sm={{ size: 2, offset: 10 }}>
                    <Button
                      className="primaryButton mt-4 d-inline-flex align-items-center justify-content-center"
                      type="button"
                      disabled={this.state.generatingCSV}
                      onClick={e => {
                        e.preventDefault();
                        this.setState(state => ({
                          ...state,
                          generatingCSV: true
                        }));

                        this.props.generateCSVByPartner(
                          () =>
                            this.setState(state => ({
                              ...state,
                              generatingCSV: false
                            })),
                          this.state.search
                        );
                      }}
                    >
                      {this.state.generatingCSV ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm mr-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Generando...
                        </>
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faFileCsv} className="mr-2" />
                          Exportar a CSV
                        </>
                      )}
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <PagedTable
                      data={this.state.binnacles}
                      columns={this.headers}
                      fetchData={this.onFetchData}
                      searching={this.state.searching}
                      defaultPageSize={100}
                    />
                  </Col>
                </Row>
              </Col>
            ) : (
              <Col sm="12">
                <div className="text-center p-5 bg-light rounded">
                  <p className="mb-0">
                    No se encontraron registros para los filtros seleccionados
                  </p>
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(Binnacles));
